import { WebsiteVehicleList } from "models/websiteVehicleList";
import { numberWithCommas } from "utils/commonUtils";
import useImageUtil from "utils/ImageUtil";
import { stringMinify } from "utils/StringUtils";
import PureCarsImage from "./PureCarsImage";
import AutoImage from "./AutoImage";
import SwiperImage from "components/SwiperImage/SwiperImage";
import Link from "next/link";
import TrueFramePlugin from "../VDP/TrueFramePlugin";

const CardView = ({ srpSettings, thirdParty, companyInfo, items }: any) => {
    const tpiSettingsJson = thirdParty;

    const showPrice = srpSettings.showPrice;
    const overridePriceByText = srpSettings.overridePriceByText;
    const overridePriceText = srpSettings.overridePriceText;
    const forceImageOverSSL = srpSettings.forceImageOverSSL;
    const stockPhoto = srpSettings.stockPhoto;

    const enableMultipleImages = srpSettings.enableMultipleImages ?? false;

    const { renderImage } = useImageUtil({
        stockPhoto,
        forceImageOverSSL,
    });

    const showPaymentAmount = srpSettings.showPaymentAmount;
    const term = srpSettings.term;
    const paymentTemplate = srpSettings.paymentTemplate || "";

    const showButton1 = srpSettings.showButton1;
    const textButton1 = srpSettings.textButton1;
    const linkButton1 =
        srpSettings.customLinkButton1 ?? srpSettings.linkButton1;
    const openInNewPageButton1 = srpSettings.openInNewPageButton1 ?? false;

    const showButton2 = srpSettings.showButton2;
    const textButton2 = srpSettings.textButton2;
    const linkButton2 =
        srpSettings.customLinkButton2 ?? srpSettings.linkButton2;
    const openInNewPageButton2 = srpSettings.openInNewPageButton2 ?? false;

    const defaultImageAsThumbnail =
        srpSettings.defaultImageAsThumbnail || "image0";

    //   const useLesaVideo = tpiSettingsJson.useLesaVideo;
    //   const scriptLesaVideo = tpiSettingsJson.scriptLesaVideo;
    //   const showLesaVideoInSRP = tpiSettingsJson.showLesaVideoInSRP;

    const useDealerCenter = tpiSettingsJson.useDealerCenter;
    const useDealerCenterInSRP = tpiSettingsJson.useDealerCenterInSRP;

    const showPureCarsValueReport = companyInfo.companyCode == 185;

    const useInstantQuote = tpiSettingsJson.useInstantQuote;
    const useInstantQuoteInSRP = tpiSettingsJson.useInstantQuoteInSRP;
    const hashInstantQuote = tpiSettingsJson.hashInstantQuote;

    const useOrbeeAuto = tpiSettingsJson.useOrbeeAuto;
    const idOrbeeAuto = tpiSettingsJson.idOrbeeAuto;
    const showOrbeeInSRP = tpiSettingsJson.showOrbeeInSRP;

    const useTrueFrame360 = tpiSettingsJson.useTrueFrame360;
    const useTrueFrame360InSRP = tpiSettingsJson.useTrueFrame360InSRP;
    const trueFrame360Script = tpiSettingsJson.trueFrame360Script;

    return items?.map((item: WebsiteVehicleList, index: number) => {
        const makePar = item.make.replace("&", "AND").replace(" ", "-").replace('/', '%2F');
        const modelPar = item.model.replace("&", "AND").replace(" ", "-").replace('/', '%2F');
        const urlComplement = `/carsforsale/${item.year}-${makePar}-${modelPar}-${item.lotName}-${item.lotState}-Stock=${item.stockNumber}`;
        const altImage = `${companyInfo.companyName} - Used ${makePar} ${modelPar} ${item.year} ${item.lotName} ${item.trim}`;
        const vehicleName = item.year + " " + item.make + " " + item.model + " " + item.trim;
        const internetPrice = item.internetPrice ?? 0;

        const imageValue = renderImage(item[defaultImageAsThumbnail.toLowerCase()] as string);

        const images: string[] = [];
        if (item.image0) images.push(item.image0);
        if (item.image1) images.push(item.image1);
        if (item.image2) images.push(item.image2);
        if (item.image3) images.push(item.image3);
        if (item.image4) images.push(item.image4);
        if (item.image5) images.push(item.image5);

        if(images.length == 0) {
            images.push("/static/images/CarInTransit.png");
        }

        return (
            <div className={`car-item text-center card-view ${index}`} key={item.stockNumber}>
                <div className="car-image">
                    <Link title={vehicleName} href={urlComplement}>
                        {enableMultipleImages && images.length > 0 &&
                            <SwiperImage
                                images={images}
                                altImage={altImage}
                                width={600}
                                height={335}
                                useNavigation={false}
                                slidesPerView={1}
                                showFullScreen={false}
                                usePagination={true}
                                isSRPage={true}
                            />
                        }
                        {!enableMultipleImages &&
                            <AutoImage
                                src={imageValue}
                                alt={altImage}
                                width={600}
                                height={335}
                                shouldResizeImg={imageValue?.toLowerCase().includes('intransit') ? false : item.hasResizedImages}
                                loadingType={(index === 0 || index === 1 || index === 2) ? "eager" : "lazy"}
                            />
                        }
                    </Link>
                    {useOrbeeAuto && idOrbeeAuto && showOrbeeInSRP
                        && <div className="ax-save-favorite-detail" dangerouslySetInnerHTML={{
                            __html: `<orb data-plugin-id=${idOrbeeAuto}
                            data-type="favorites-toggle"
                            data-vin=${item.vin}>
                        </orb>`}} />
                    }
                </div>
                {/* {useLesaVideo && showLesaVideoInSRP &&
                        <div className="les_video" les_vin={item.vin}></div>
                    } */}
                <div className="car-content">
                    <div className="row ax-car-info">
                        <div className="col-md-7 col-xs-7">
                            <Link className="ax-vehicle-title-car text-left" title={vehicleName} href={urlComplement}>
                                <p>{`${item.year} ${item.make} ${item.model}`}</p>
                                <span>{item.trim ?? "&nbsp;"}</span>
                            </Link>
                            <div className="ax-car-info-miles">
                                {numberWithCommas(Number(item.miles))} miles
                            </div>
                        </div>
                        {useInstantQuote && useInstantQuoteInSRP &&
                            <div className="col-md-5 col-xs-5 p-l-0">
                                <div id={`lead-capture-widget-${item.vin}`}
                                    className="lead-capture-widget"
                                    data-dealershipHash={hashInstantQuote}
                                    data-vehicleVin={item.vin} style={{ display: 'none' }}>
                                    {/* <widget-button v-on:click="openWidget"></widget-button>
                            <widget-app v-if="showWidget"></widget-app> */}
                                </div>
                            </div>
                        }
                        <div className="col-md-5 col-xs-5 p-l-0">
                            <div className="price text-right">
                                {showPrice && internetPrice > 0 &&
                                    (showPureCarsValueReport ? (
                                        <div className="button red width-100">
                                            <a
                                                target="_blank"
                                                href={`//vr.purecars.com/comparison/100016328/${item.vin}`}
                                                rel="noreferrer"
                                            >
                                                <PureCarsImage vin={item.vin} />
                                            </a>
                                            <Link className="custom-price" href={urlComplement}>
                                                ${numberWithCommas(internetPrice)}
                                            </Link>
                                        </div>
                                    ) : (
                                        <Link className="lbl-price text-red lbl-price-mobile" title={vehicleName} href={urlComplement}>
                                            ${numberWithCommas(internetPrice)}
                                        </Link>
                                    ))}

                                {showPrice && internetPrice <= 0 && (
                                    <Link className="ax-hidden-price lbl-price text-red" title={vehicleName} href={urlComplement}>
                                        More Details
                                    </Link>
                                )}

                                {!showPrice && overridePriceByText && overridePriceText !== "" && (
                                    <>
                                        {overridePriceText}
                                        <Link className="ax-hidden-price lbl-price text-red" title={vehicleName} href={urlComplement}>
                                            More Details
                                        </Link>
                                    </>
                                )}

                                {showPaymentAmount && (item.websitePayment > 0) && (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: stringMinify(
                                                paymentTemplate
                                                    .replace("[PaymentAmount]", item.websitePayment ?? "")
                                                    .replace("[Term]", term)
                                                    .replace("[StockNumber]", item.stockNumber)
                                            ),
                                        }}
                                    ></div>
                                )}

                                {item.homeDelivery && (
                                    <div className="ax-home-delivery-lbl">Home delivery only</div>
                                )}
                            </div>
                            {useTrueFrame360 && useTrueFrame360InSRP &&
                                <TrueFramePlugin vin={item.vin}
                                    trueFrameScript={trueFrame360Script}
                                    trueFrameType="tf360srp"
                                />
                            }
                        </div>
                    </div>
                    {showButton1 && (
                        <a
                            href={
                                linkButton1 === "/financing"
                                    ? `${linkButton1}?stock=${item.stockNumber}`
                                    : linkButton1
                            }
                            target={openInNewPageButton1 ? "_blank" : "_self"}
                            className="css_btn cardbtn1"
                            rel="noreferrer"
                            title={vehicleName}
                        >
                            <i className="fa fa-tag"></i>
                            {textButton1}
                        </a>
                    )}

                    {showButton2 && (
                        <a href={
                            linkButton2 === "/financing"
                                ? `${linkButton2}?stock=${item.stockNumber}`
                                : linkButton2
                        }
                        target={openInNewPageButton2 ? "_blank" : "_self"}
                        className="css_btn cardbtn2"
                        rel="noreferrer"
                        title={vehicleName}
                        >
                            <i className="fa fa-money"></i>
                            {textButton2}
                        </a>
                    )}

                    {useDealerCenter && useDealerCenterInSRP && (
                        <div className="row p-t-10">
                            <div className="col-md-12">
                                <div
                                    className="carzing-widget"
                                    data-carmojo-theme="modern-medium"
                                    data-carmojo-price={internetPrice}
                                    data-carmojo-vin={item.vin}
                                    data-carmojo-primary-image-url={imageValue}
                                ></div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    });
};

export default CardView;